import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Button from "../button/Button";
import { getBtnTxt, openBtnTxt } from "../messages";
import CommonMainList from "./CommonMainList";
import CommonVideoImageComponent from "./CommonVideoImageComponent";
import {
  handleOpenAppDetailDialogAndPassDetails,
  handleOpenAppDialog,
} from "../constants";
import { loaderImg } from "../images";
import TruncatedTextTooltip from "../TruncatedTextTooltip";

const BannerTile = ({ collectionData }) => {
  const {
    logo_images,
    asset_url,
    thumbnail_url,
    asset_type,
    description,
    display_name,
    is_app_installed,
    id,
  } = collectionData?.[0] || {};

  const [imgSrc, setImgSrc] = useState(logo_images?.original);

  useEffect(() => {
    if (logo_images) {
      setImgSrc(logo_images?.original);
    }
  }, [logo_images]);

  const isVideo = asset_type === "video";

  const handleOpenDetailDialog = () => {
    if (is_app_installed) {
      handleOpenAppDialog({
        data: collectionData?.[0],
      });
    } else {
      //open app detail page and pass details to modal
      handleOpenAppDetailDialogAndPassDetails({
        id,
      });
    }
  };

  return (
    <Box className="banner-tile-wrapper" padding="0 15px">
      <Box
        className="banner-tile-box"
        onClick={handleOpenDetailDialog}
        sx={{ cursor: "pointer" }}
      >
        {/* Show video or image according to the asset_type */}
        <CommonVideoImageComponent
          isVideo={isVideo}
          asset_url={asset_url}
          thumbnail_url={thumbnail_url}
          isFrom="banner-tile"
        />
        {/* Overlay text and button */}
        <Box className="banner-text">
          <Box className="right-side-text">
            <img
              src={imgSrc || loaderImg}
              height="54px"
              width="54px"
              className="logo-image"
              alt="logo"
              onError={() => setImgSrc(loaderImg)}
            />

            <Box
              display="flex"
              flexDirection="column"
              className="text-truncate"
            >
              <TruncatedTextTooltip
                textProps={{
                  className: "white-text-only",
                  font: "semibold",
                }}
                textValue={display_name}
                fontSize={16}
              />
              <TruncatedTextTooltip
                textProps={{
                  className: "white-text-only",
                  font: "regular",
                }}
                textValue={description}
                fontSize={12}
              />
            </Box>
          </Box>
          <Button
            label={is_app_installed ? openBtnTxt : getBtnTxt}
            fullWidth={false}
            variant={is_app_installed ? "contained" : "outlined"}
            className="get-button"
            sx={{ color: is_app_installed ? "#ffffff" : "#003acc" }}
            textClass="font-12"
          />
        </Box>
      </Box>
      <CommonMainList collectionData={collectionData} />
    </Box>
  );
};

export default BannerTile;
